import {IRoomRunFile} from '../incase-domain/proptypes/IRoomRunFile';
import {httpGetWithoutIntercept, httpPost, httpPostWithoutIntercept, httpPut} from './http.service';
import {ISlide} from '../incase-domain/slide';
import {socket} from '../util/socket';
import {IFetchRoom, IFetchRoomProtection} from '../incase-domain/rooms/room.player';
import {ISocketQuestionAnswerPrompt} from '../incase-domain/elements/question/ISocketQuestionPrompt';
import {getAnonymousPresenterHash, removeAnonymousPresenterHash} from '../util/token.utils';

export const createRoomRunFile = (
    roomId: string,
    requestParams?: Record<string, string>,
    presenterCode?: string,
    hash?: string
): Promise<IRoomRunFile> => {
    return httpPost(`player/createRoomRunFile/`, {
        roomId,
        requestParams,
        presenterCode,
        hash,
    }).then((response) => {
        return response;
    });
};

export function startRoom(): void {
    socket && socket.emit('startRoom');
}

export function stopRoom(): void {
    const presenterHash = getAnonymousPresenterHash();
    socket && socket.emit('stopRoom', presenterHash);
    removeAnonymousPresenterHash();
}

export function saveRoomRunFile(roomRunFile: IRoomRunFile): void {
    socket && socket.emit('updateRoomRunfile', roomRunFile);
}

export function updateAnsweredQuestionCount(data: ISocketQuestionAnswerPrompt): void {
    socket && socket.emit('userQuestionResponse', data);
}

export const fetchRoom = (id: string, credential: string | null, hash?: string, presenterCode?: string): Promise<IFetchRoom> => {
    const authorization = credential;
    return httpPostWithoutIntercept(`player/room/${id}`, {hash, presenterCode}, {headers: {authorization}}).then((response) => {
        return response;
    });
};
export const fetchRoomProtection = (id: string): Promise<IFetchRoomProtection> => {
    return httpGetWithoutIntercept(`player/roomProtection/${id}`).then((response) => {
        return response;
    });
};

export const fetchRoomRunFileByRoomId = (roomId: string): Promise<IRoomRunFile> => {
    return httpGetWithoutIntercept(`player/roomRunFileByRoomId/${roomId}`).then((response) => {
        return response;
    });
};

export const updateRoomWithRunfileId = (roomId: string, roomRunFileId: string): Promise<IFetchRoom> => {
    return httpPut(`player/updateRoom/${roomId}`, {roomRunFileId}).then((response) => {
        return response;
    });
};
export const fetchRoomPresentationSlides = (
    roomId: string,
    size: number,
    page: number,
    credential: string | null,
    loadingState: (state: number) => void,
    hash?: string,
    presenterCode?: string
): Promise<ISlide[]> => {
    const authorization = credential;

    const queryParams = new URLSearchParams();
    if (hash) queryParams.set('hash', hash);
    if (presenterCode) queryParams.set('presenterCode', presenterCode);
    const queryString = queryParams.toString();
    const url = `player/room/${roomId}/slides/${size}/${page}${queryString ? `?${queryString}` : ''}`;

    return httpGetWithoutIntercept(url, {
        headers: {authorization},
        onDownloadProgress: (e: {total: number | undefined; loaded: number}) => {
            if (e.total !== undefined) {
                loadingState((e.loaded * 100) / e.total);
            }
        },
    }).then((response) => {
        return response.slides;
    });
};
